<template>
  <div class="sign-pg">
    <div class="sign-row">
      <div class="sign-form-top">
        <h2>{{ $t('Изменить пароль') }}</h2>
      </div>
      <form @submit.prevent="resetPass">
        <div class="form-group password">
          <div style="position: relative;">
            <input
              id="password"
              :type="passwordFieldType"
              v-model.trim="password"
              class="form-control"
              :class="{
                invalid:
                  ($v.password.$dirty && !$v.password.required) ||
                  ($v.password.$dirty && !$v.password.minLength)
              }"
              placeholder="Новый пароль"
            />
          </div>
          <small
            class="helper-text invalid"
            v-if="$v.password.$dirty && !$v.password.required"
          >
            {{ $t('Введите пароль') }}
          </small>
          <small
            class="helper-text invalid"
            v-else-if="$v.password.$dirty && !$v.password.minLength"
          >
            {{ $t('Пароль должен быть') }}
            {{ $v.password.$params.minLength.min }} {{ $t('символов') }}.
            {{ $t('Сейчас он') }}
            {{ password.length }}
          </small>
        </div>
        <div class="form-group password">
          <div style="position: relative;">
            <input
              id="repeatedPassword"
              :type="passwordFieldType"
              v-model.trim="repeatedPassword"
              class="form-control"
              :class="{
                invalid:
                  ($v.repeatedPassword.$dirty &&
                    !$v.repeatedPassword.required) ||
                  ($v.repeatedPassword.$dirty && !$v.repeatedPassword.minLength)
              }"
              placeholder="Подтвердите пароль"
            />
          </div>
          <small
            class="helper-text invalid"
            v-if="!$v.repeatedPassword.sameAsPassword"
          >
            {{ $t('Пароли должны быть идентичны') }}
          </small>
        </div>

        <button class="btn btn-default grad" type="submit">
          {{ $t('Изменить пароль') }}
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import { minLength, sameAs, required } from 'vuelidate/lib/validators'
import messages from '@/utils/messages'
import User from '@/model/user'
import { mapMutations } from 'vuex'
import {Trans} from "@/plugins/Translation"

export default {
  name: 'password-reset-token',
  data() {
    return {
      password: null,
      repeatedPassword: null,
      token: null
    }
  },
  validations: {
    password: { required, minLength: minLength(8) },
    repeatedPassword: { sameAsPassword: sameAs('password') }
  },
  computed: {
    passwordFieldType() {
      return this.showPassword ? 'text' : 'password'
    }
  },
  mounted() {
    this.token = this.$route.params.token
    if (messages[this.$route.query.message]) {
      this.$message(messages[this.$route.query.message])
    }
  },
  created() {
    this.scrollToTop()
  },
  methods: {
    ...mapMutations(['setLoading']),
    resetPass() {
      if (this.$v.$invalid) {
        this.$v.$touch()
        return
      }
      this.setLoading(true)
      if (this.password === this.repeatedPassword) {
        User.resetPassword(this.token, { pass: this.password })
          .then((response) => {
            const result = response.data
            this.setLoading(false)
            if (result.result == 'success') {
              alert(this.$i18n.t('Вы успешно поменяли свой пароль'))
              this.$router.push(Trans.i18nRoute({ name: 'login' }))
            }
          })
          .catch((error) => {
            this.setLoading(false)
            if (error.response.status === 404)
              alert(this.$i18n.t('Пользователь с таким токеном не найден'))
          })
      }
    },
    scrollToTop() {
      window.scrollTo(0, 0)
    }
  }
}
</script>
